
import { Component, Vue, Prop } from "vue-property-decorator";
import {
  ZuzhijiagouList,
  UsersList,
  UsersAllList,
  DiseaseAllList,
  AdminPatientList,
  DeletePatient,
  zhuanyue,
  searchBiaoqian,
} from "@/request/doctor";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import NavLeft from "../../../main/components/nav-left/nav-left.vue";
import Pagination from "@/components/paginaiton.vue";
@Component({
  components: {
    MainHeader,
    NavLeft,
    Pagination,
  },
})
export default class PatientDangan extends Vue {
  private doctor: any = "";
  private doctors: any = [];
  private ifShowQianyue: any = false;
  private curData: any = {};
  private filter: any = {
    search: "",
    institution_id: "",
    doctor_id: "",
    disease_id: "",
    签约状态: "",
    current_page: 1,
    page_count: 10,
    sort_value: 1,
  };
  private totalCount: any = null;
  private totalPage: any = 0;
  private window: any = window;
  private users: any[] = [];
  private jigous: any[] = [];
  private yishengs: any[] = [];
  private diseases: any[] = [];
  private biaoqians: any = [];
  private zhuangtais: any[] = ["未签约", "已签约"];
  private H: any = "";
  private get localFilter() {
    if (!localStorage.getItem("danganFilter")) {
      return {};
    } else {
      return JSON.parse(localStorage.getItem("danganFilter") || "");
    }
  }
  private set localFilter(val) {
    if (!val) {
      return;
    }
    localStorage.setItem("danganFilter", JSON.stringify(val));
  }
  private getText(arr: any, key: any) {
    let result = "";
    if (!arr || arr.length == 0) {
      return result;
    }
    arr.forEach((ele: any, i: any) => {
      if (i > 0) {
        result += "、";
      }
      result += ele[key];
    });
    return result;
  }
  private focus(e: any) {
    if (e) {
      this.remoteBiaoqian("");
    }
  }
  private doctorFocus(e: any) {
    if (e) {
      this.remoteDoctor("");
    }
  }
  private remoteBiaoqian(e: any) {
    const params: any = {
      params: {
        search: e,
      },
    };
    searchBiaoqian(this, params).then((res: any) => {
      this.biaoqians = res;
    });
  }
  private remoteDoctor(e: any) {
    const params: any = {
      params: {
        search: e,
        data_type: "创建医生",
      },
    };
    searchBiaoqian(this, params).then((res: any) => {
      this.doctors = res;
    });
  }
  /**
   * @description 搜索
   */
  private search() {
    this.filter.current_page = 1;
    this.fetchUsers();
  }
  /**
   * @description 处理排序变化
   */
  private handleSortChange(ev: any) {
    this.filter.sort_value = ev["order"] === "ascending" ? "1" : "0";
    this.search();
  }
  /**
   * @description 处理页码变化
   */
  private handleCurrentPageChange(val: any) {
    this.filter.current_page = val;
    this.fetchUsers();
  }
  /**
   * @description 处理翻页器的每页条数变化
   */
  private handleCurrentSizeChange(val: any) {
    this.filter.current_page = 1;
    this.filter.page_count = val;
    this.fetchUsers();
  }
  /**
   * @description 获取组织架构列表
   */
  private fetchJigouList() {
    const params: any = {};
    const jigous: any[] = [];
    ZuzhijiagouList(this, params).then((data: any) => {
      data.forEach((first: any) => {
        jigous.push(first);
        if (first["sub_institutions"]) {
          first["sub_institutions"].forEach((second: any) => {
            jigous.push(second);
            if (second["sub_institutions"]) {
              second["sub_institutions"].forEach((third: any) => {
                jigous.push(third);
              });
            }
          });
        }
      });
      this.jigous = jigous;
    });
  }
  /**
   * @description 机构变化
   */
  private jigouChange() {
    this.filter.doctor_id = "";
    this.fetchYishengs();
    this.search();
  }
  /**
   * @description 获取医生列表
   */
  private fetchYishengs() {
    const params: any = {
      institution_id: this.filter.institution_id,
    };
    UsersAllList(this, params).then((data: any) => {
      this.yishengs = data.doctors;
    });
  }
  /**
   * @description 慢病列表
   */
  private fetchManbings() {
    DiseaseAllList(this).then((data: any) => {
      this.diseases = data;
    });
  }
  /**
   * @description 获取用户列表
   */
  private fetchUsers() {
    const loading = this.$loading({
      lock: true,
      text: "加载中……",
      spinner: "el-icon-loading",
      customClass: "loadClass",
      background: "rgba(255, 255, 255, 0.7)",
    });
    const params = {
      search: this.filter.search,
      current_page: this.filter.current_page,
      page_count: this.filter.page_count,
      sort_value: this.filter.sort_value,
      客户标签: this.filter["标签"].concat(this.filter.doctor),
    };
    AdminPatientList(this, params)
      .then((data: any) => {
        loading.close();
        this.localFilter = this.filter;
        this.users = data.patients;
        this.totalCount = data.total_count;
        this.totalPage = data.total_page;
      })
      .catch(() => {
        loading.close();
        localStorage.setItem("danganFilter", "");
      });
  }

  /**
   * @description 跳转档案详情
   */
  private gotoDetail(part: any, patient: any) {
    this.$router.push({
      path: "/main/patient/dangan-edit-message",
      query: {
        patient_id: patient.patient_id,
      },
    });
  }
  private zhuanyue(item: any) {
    this.curData = item;
    this.ifShowQianyue = true;
  }
  private zhuanyueSure() {
    const params: any = {};
    zhuanyue(this, params).then((res: any) => {});
  }
  private deleteOne(item: any) {
    this.$confirm("您确定需要删除该患者么？删除后该患者的全部数据都将清空。")
      .then(() => {
        const params: any = {
          data: {
            patient_id: item.patient_id,
          },
        };
        DeletePatient(this, params).then((data: any) => {
          this.$message.success("删除成功");
          this.fetchUsers();
        });
      })
      .catch((e) => {
        console.log("取消了");
      });
  }
  mounted() {
    this.H = document.body.clientHeight - 100;
    if (localStorage.getItem("danganFilter")) {
      this.filter = JSON.parse(localStorage.getItem("danganFilter") as any);
    }
    this.remoteBiaoqian("");
    this.remoteDoctor("");
    this.fetchUsers();
  }
}
